import { viewerStrings } from '../copy/strings.js';
import { hasText, optionalText } from '../copy/text.js';
export function ReferenceLinks() {
  if (
    ![
      viewerStrings.webComponentsReferenceLinks.cUCMOverview,
      viewerStrings.webComponentsReferenceLinks.cDRFieldReference,
      viewerStrings.webComponentsReferenceLinks.cUCMCauseCodes,
    ].some(hasText)
  )
    return null;
  return (
    <nav
      className="reference-links workspace-tools"
      aria-label={optionalText(viewerStrings.webComponentsReferenceLinks.cUCMReferences)}
    >
      {hasText(viewerStrings.webComponentsReferenceLinks.cUCMOverview) ? (
        <a href="/tools/cdr-clarity/cucm/">
          {viewerStrings.webComponentsReferenceLinks.cUCMOverview}
        </a>
      ) : null}
      {hasText(viewerStrings.webComponentsReferenceLinks.cDRFieldReference) ? (
        <a href="/tools/cdr-clarity/cucm/cdr-fields/">
          {viewerStrings.webComponentsReferenceLinks.cDRFieldReference}
        </a>
      ) : null}
      {hasText(viewerStrings.webComponentsReferenceLinks.cUCMCauseCodes) ? (
        <a href="/tools/cdr-clarity/cucm/cause-codes/">
          {viewerStrings.webComponentsReferenceLinks.cUCMCauseCodes}
        </a>
      ) : null}
    </nav>
  );
}
